var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCubeOpen = function SvgCubeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "m8.5 10.237 2.483.673-2.483.673v-1.346zm-1-4.485L5.016 5.08 7.5 4.406v1.346zm1 0V4.406l2.484.673-2.484.673zm0 1.037 3.588-.973v4.358L8.5 9.201V6.79zm-1 3.448v1.346l-2.483-.673 2.483-.673zm0-1.036-3.588.973V5.816L7.5 6.79v2.412zm5.219-4.688L8.131 3.27c-.006-.002-.012 0-.018 0-.037-.01-.074-.005-.113-.005-.038 0-.074-.005-.111.004l-.02.001-4.588 1.243a.5.5 0 0 0-.369.483v5.998c0 .225.151.424.369.482l4.588 1.242a.487.487 0 0 0 .262 0l4.588-1.242a.499.499 0 0 0 .369-.482V4.996a.5.5 0 0 0-.369-.483z"
  })));
};
export default SvgCubeOpen;